<template>
    <div class="recover-container">
        <div class="recover-box">
            <h2 class="title">修改密码</h2>
            <el-form :model="recoverForm" status-icon :rules="rules" ref="recoverForm" class="login-ruleForm">
                <el-form-item prop="account">
                    <el-input v-model="recoverForm.account" disabled placeholder="账户"></el-input>
                </el-form-item>
<!--                <el-form-item prop="oldPassword">-->
<!--                    <el-input id="oldPassword" type="text" v-model="recoverForm.oldPassword" placeholder="旧密码"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item prop="password">
                    <el-input id="password" type="text" v-model="recoverForm.password" placeholder="新密码"></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                    <el-input id="checkPass" type="text" v-model="recoverForm.checkPass" placeholder="确认新密码"></el-input>
                </el-form-item>
                <el-form-item>

                  <el-row class="submit-button"   type="flex" justify="space-around">
                    <el-col :span="24"  >
                      <el-button style="width: 100%" :disabled="isChanging"  type="primary" @keyup.enter.native="submitLoginForm(recoverForm)" @click="submitLoginForm(recoverForm)">提 交
                      </el-button>
                    </el-col>

<!--                    <el-col :span="12">-->
<!--                      <el-button  style="width: 100%" :disabled="isChanging" type="primary" @click="back">返 回-->
<!--                      </el-button>-->
<!--                    </el-col>-->
                  </el-row>


                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import apiDataFilter from "../utils/apiDataFilter";
import Cookies from 'js-cookie';
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.recoverForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };

        return {
            recoverForm: {
                account: '',
                oldPassword: '',
                password: '',
                checkPass : ''
            },
          isChanging : false,
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                //oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.recoverForm.account = Cookies.get('ldapAccount')
        this.recoverForm.oldPassword = ''

    },
  watch: {
    'recoverForm.password': function (val) {
      this.setPwdType('password', val)
    },
    'recoverForm.oldPassword': function (val) {
      this.setPwdType('oldPassword', val)
    },
    'recoverForm.checkPass': function (val) {
      this.setPwdType('checkPass', val)
    },
  },
    methods: {
      setPwdType(id,val){
        let len = val?val.length : 0
        if(len){
          document.getElementById(id).setAttribute('type','password');
        }else{
          document.getElementById(id).setAttribute('type','text');
        }
      },
        back(){
          this.$router.push('/')
          this.$router.go(0)

        },
        submitLoginForm() {

            this.isChanging = true
            this.$refs.recoverForm.validate((valid) => {
                if (valid) {
                    apiDataFilter
                        .request({
                            api: "reset.resetPassword",
                            method: "post",
                            data: this.recoverForm
                        })
                        .then((res) => {
                            if (res.data.result) {
                                this.$message({
                                    message: "密码重置成功，请重新登录！",
                                    type: 'success' ,
                                    duration : 2000,
                                    onClose :function (){
                                      apiDataFilter.removeCookies()
                                      localStorage.clear()
                                      window.location.href = '/login'
                                    }
                                })


                            } else {
                              this.isChanging = false
                                this.$message({
                                    message: res.data.message,
                                    type: 'warning'
                                })
                            }
                        })
                } else {
                    this.isChanging = false
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
.recover-container {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    .recover-box {
        position: absolute;
        top: 144px;
        left: 40%;
        width: 20%;
    }
    .submit-button {
        //width: 30%;
        margin: 0 auto;
        margin-top: 40px;
    }
}
</style>